"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeFromConfig = exports.staticCheckmarkListNode = exports.checkmarkListNode = exports.headerNode = exports.textBoxNode = exports.signatureNode = exports.tableNode = exports.errorNode = exports.markdownNode = void 0;
const types_1 = require("./types");
const markdownNode = __importStar(require("./markdownNode"));
const tableNode = __importStar(require("./tableNode"));
const signatureNode = __importStar(require("./signatureNode"));
const errorNode = __importStar(require("./errorNode"));
const textBoxNode = __importStar(require("./textBoxNode"));
const headerNode = __importStar(require("./headerNode"));
const checkmarkListNode = __importStar(require("./checkmarkListNode"));
const staticCheckmarkListNode = __importStar(require("./staticCheckmarkListNode"));
__exportStar(require("./types"), exports);
exports.markdownNode = __importStar(require("./markdownNode"));
exports.errorNode = __importStar(require("./errorNode"));
exports.tableNode = __importStar(require("./tableNode"));
exports.signatureNode = __importStar(require("./signatureNode"));
exports.textBoxNode = __importStar(require("./textBoxNode"));
exports.headerNode = __importStar(require("./headerNode"));
exports.checkmarkListNode = __importStar(require("./checkmarkListNode"));
exports.staticCheckmarkListNode = __importStar(require("./staticCheckmarkListNode"));
const nodeFromConfig = (config) => {
    try {
        let node;
        switch (config.type) {
            case types_1.NodeTypes.MarkdownNode:
                node = markdownNode.MarkdownNode(config);
                break;
            case types_1.NodeTypes.TableNode:
                node = tableNode.TableNode(config);
                break;
            case types_1.NodeTypes.SignatureNode:
                node = signatureNode.SignatureNode(config);
                break;
            case types_1.NodeTypes.TextBoxNode:
                node = textBoxNode.TextBoxNode(config);
                break;
            case types_1.NodeTypes.HeaderNode:
                node = headerNode.HeaderNode(config);
                break;
            case types_1.NodeTypes.CheckmarkListNode:
                node = checkmarkListNode.CheckmarkListNode(config);
                break;
            case types_1.NodeTypes.StaticCheckmarkListNode:
                node = staticCheckmarkListNode.StaticCheckmarkListNode(config);
                break;
            default:
                node = errorNode.ErrorNode();
                break;
        }
        return Object.assign({ options: config.options }, node);
    }
    catch (_a) {
        return errorNode.ErrorNode();
    }
};
exports.nodeFromConfig = nodeFromConfig;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL25vZGVzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxtQ0FBMEQ7QUFDMUQsNkRBQStDO0FBQy9DLHVEQUF5QztBQUN6QywrREFBaUQ7QUFDakQsdURBQXlDO0FBQ3pDLDJEQUE2QztBQUM3Qyx5REFBMkM7QUFDM0MsdUVBQXlEO0FBQ3pELG1GQUFxRTtBQUVyRSwwQ0FBdUI7QUFDdkIsK0RBQStDO0FBQy9DLHlEQUF5QztBQUN6Qyx5REFBeUM7QUFDekMsaUVBQWlEO0FBQ2pELDZEQUE2QztBQUM3QywyREFBMkM7QUFDM0MseUVBQXlEO0FBQ3pELHFGQUFxRTtBQUU5RCxNQUFNLGNBQWMsR0FBRyxDQUFDLE1BQWtCLEVBQWEsRUFBRTtJQUM5RCxJQUFJO1FBQ0YsSUFBSSxJQUFJLENBQUM7UUFDVCxRQUFPLE1BQU0sQ0FBQyxJQUFJLEVBQUU7WUFDbEIsS0FBSyxpQkFBUyxDQUFDLFlBQVk7Z0JBQ3pCLElBQUksR0FBRyxZQUFZLENBQUMsWUFBWSxDQUFDLE1BQXFDLENBQUMsQ0FBQztnQkFDeEUsTUFBTTtZQUNSLEtBQUssaUJBQVMsQ0FBQyxTQUFTO2dCQUN0QixJQUFJLEdBQUcsU0FBUyxDQUFDLFNBQVMsQ0FBQyxNQUErQixDQUFDLENBQUM7Z0JBQzVELE1BQU07WUFDUixLQUFLLGlCQUFTLENBQUMsYUFBYTtnQkFDMUIsSUFBSSxHQUFHLGFBQWEsQ0FBQyxhQUFhLENBQUMsTUFBdUMsQ0FBQyxDQUFDO2dCQUM1RSxNQUFNO1lBQ1IsS0FBSyxpQkFBUyxDQUFDLFdBQVc7Z0JBQ3hCLElBQUksR0FBRyxXQUFXLENBQUMsV0FBVyxDQUFDLE1BQW1DLENBQUMsQ0FBQztnQkFDcEUsTUFBTTtZQUNSLEtBQUssaUJBQVMsQ0FBQyxVQUFVO2dCQUN2QixJQUFJLEdBQUcsVUFBVSxDQUFDLFVBQVUsQ0FBQyxNQUFpQyxDQUFDLENBQUM7Z0JBQ2hFLE1BQU07WUFDUixLQUFLLGlCQUFTLENBQUMsaUJBQWlCO2dCQUM5QixJQUFJLEdBQUcsaUJBQWlCLENBQUMsaUJBQWlCLENBQUMsTUFBOEMsQ0FBQyxDQUFDO2dCQUMzRixNQUFNO1lBQ04sS0FBSyxpQkFBUyxDQUFDLHVCQUF1QjtnQkFDcEMsSUFBSSxHQUFHLHVCQUF1QixDQUFDLHVCQUF1QixDQUNwRCxNQUEwRCxDQUMzRCxDQUFDO2dCQUNGLE1BQU07WUFDVjtnQkFDRSxJQUFJLEdBQUcsU0FBUyxDQUFDLFNBQVMsRUFBRSxDQUFDO2dCQUM3QixNQUFNO1NBQ1Q7UUFFRCx1QkFBUyxPQUFPLEVBQUUsTUFBTSxDQUFDLE9BQU8sSUFBSyxJQUFJLEVBQUU7S0FDNUM7SUFBQyxXQUFNO1FBQ04sT0FBTyxTQUFTLENBQUMsU0FBUyxFQUFFLENBQUM7S0FDOUI7QUFDSCxDQUFDLENBQUM7QUFwQ1csUUFBQSxjQUFjLGtCQW9DekIifQ==